import { For } from "solid-js";
import { ApiError } from "@energyplatform/client";
import { errorText } from "../i18n.ts";

export function ErrorBox(props: { error: unknown }) {
  const items = () =>
    props.error instanceof ApiError
      ? props.error.errors
      : [{ code: "NETWORK", params: {} as Record<string, unknown> }];
  return (
    <div class="err" role="alert">
      <For each={items()}>{(e) => <p>{errorText(e.code, e.params)}</p>}</For>
    </div>
  );
}
